import React, { useState } from 'react';
import { LOOTBOX_RARITIES } from '../../constants/lootbox';
import { VfxSpan } from '../../utils/helpers';
import { useToast } from '../ToastContext';
import ItemIcon from './ItemIcon';

function ListingModal({ item, onClose, onListItem }) {
  const toast = useToast();
  const [price, setPrice] = useState('');
  const [auctionMode, setAuctionMode] = useState(false);
  const [auctionDuration, setAuctionDuration] = useState(24);
  const [currencyType, setCurrencyType] = useState("crewmate");

  if (!item) return null;

  const rarity = LOOTBOX_RARITIES[item.rarity];
  const isShinyGalaxy = item.isShiny && item.rarity === 'GALAXY';
  const isNuclear = item.rarity === 'NUCLEAR';

  function handleList() {
    const priceNum = parseFloat(price);
    if (priceNum > 0) {
      onListItem(item, priceNum, auctionMode, currencyType, auctionMode ? auctionDuration : undefined);
      onClose();
    } else {
      toast.warn("Please enter a valid price!");
    }
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content lootbox-reward-modal"
        onClick={(e) => e.stopPropagation()}
        style={{
          borderColor: isNuclear || isShinyGalaxy ? 'transparent' : item.isShiny ? '#FFD700' : (item.isStatTrak ? '#FF8C00' : rarity.color),
          maxWidth: '500px'
        }}
      >
        <button className="modal-close" onClick={onClose}>✕</button>

        <div className="reward-content">
          <div className="reward-header">
            <h2 style={{ color: item.isStatTrak ? '#FF8C00' : rarity.color }}>
              💰 List Item for Sale
            </h2>
          </div>

          {/* Item Preview */}
          <div
            className={`reward-item ${rarity.glow ? 'glow' : ''} ${isNuclear ? 'nuclear' : isShinyGalaxy ? 'shiny-galaxy' : item.isShiny ? 'shiny' : ''} ${item.isStatTrak ? 'stattrak' : ''}`}
            style={{
              borderColor: isNuclear || isShinyGalaxy ? 'transparent' : item.isShiny ? '#FFD700' : (item.isStatTrak ? '#FF8C00' : rarity.color),
              boxShadow: isNuclear || isShinyGalaxy
                ? ''
                : item.isShiny
                ? '0 0 40px #FFD700, 0 0 20px #FFF'
                : item.isStatTrak
                ? '0 0 40px #FF8C00, 0 0 20px #FF6B35'
                : (rarity.glow ? `0 0 30px ${rarity.color}` : 'none'),
              marginBottom: '20px'
            }}
          >
            {isNuclear ? (
              <div className="nuclear-badge">☢️ NUCLEAR ☢️</div>
            ) : isShinyGalaxy ? (
              <div className="shiny-galaxy-badge">🌌 GALAXY ✨</div>
            ) : item.isShiny && (
              <div className="shiny-badge">✨ SHINY ✨</div>
            )}
            {item.isStatTrak && (
              <div className="stattrak-badge" style={{
                position: 'absolute',
                top: item.isShiny ? '40px' : '8px',
                right: '8px',
                background: 'linear-gradient(135deg, #FF8C00, #FF6B35)',
                padding: '4px 8px',
                borderRadius: '4px',
                fontWeight: 'bold',
                fontSize: '12px',
                color: '#000',
                boxShadow: '0 0 10px #FF8C00'
              }}>
                STATTRAK™
              </div>
            )}
            <div className="reward-icon">
              {item.vfx
                ? <VfxSpan vfx={item.vfx} style={{ display: 'inline-block', fontSize: 'inherit' }}><ItemIcon item={item} size={64} /></VfxSpan>
                : <ItemIcon item={item} size={64} />}
            </div>
            <div className="reward-name" style={{ color: item.isShiny ? '#FFD700' : rarity.color }}>
              {item.vfx
                ? <VfxSpan vfx={item.vfx}>{item.name}</VfxSpan>
                : item.name}
              {item.isStatTrak && <span style={{ marginLeft: '4px', fontSize: '16px', color: '#FF8C00' }}>™</span>}
              {item.vfx && item.vfx.length > 0 && <span style={{ marginLeft: '6px', fontSize: '13px', color: '#a78bfa', fontWeight: 'bold' }}>✦ VFX{Array.isArray(item.vfx) && item.vfx.length > 1 ? ` x${item.vfx.length}` : ''}</span>}
            </div>
            <div className="reward-rarity" style={{ color: rarity.color }}>
              {rarity.name}
            </div>
          </div>

          {/* Listing Type */}
          <div className="form-group" style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Listing Type:</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                className={`listing-type-btn ${!auctionMode ? "active" : ""}`}
                onClick={() => setAuctionMode(false)}
                style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '4px',
                  border: !auctionMode ? '2px solid var(--primary-color)' : '1px solid var(--border-color)',
                  background: !auctionMode ? 'var(--primary-color)' : 'var(--bg-card)',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                💰 Buy Now (Fixed Price)
              </button>
              <button
                className={`listing-type-btn ${auctionMode ? "active" : ""}`}
                onClick={() => setAuctionMode(true)}
                style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '4px',
                  border: auctionMode ? '2px solid var(--primary-color)' : '1px solid var(--border-color)',
                  background: auctionMode ? 'var(--primary-color)' : 'var(--bg-card)',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                🔨 Auction (Accept Bids)
              </button>
            </div>
          </div>

          {/* Auction Duration */}
          {auctionMode && (
            <div className="form-group" style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Auction Duration:</label>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {[
                  { value: 1, label: '1h' },
                  { value: 6, label: '6h' },
                  { value: 12, label: '12h' },
                  { value: 24, label: '24h' },
                  { value: 48, label: '2d' },
                  { value: 72, label: '3d' },
                ].map(opt => (
                  <button
                    key={opt.value}
                    className={`listing-type-btn ${auctionDuration === opt.value ? "active" : ""}`}
                    onClick={() => setAuctionDuration(opt.value)}
                    style={{
                      flex: '1 1 auto',
                      minWidth: '50px',
                      padding: '10px',
                      borderRadius: '4px',
                      border: auctionDuration === opt.value ? '2px solid var(--primary-color)' : '1px solid var(--border-color)',
                      background: auctionDuration === opt.value ? 'var(--primary-color)' : 'var(--bg-card)',
                      cursor: 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Currency Type */}
          <div className="form-group" style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Currency Type:</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button
                className={`currency-select-btn ${currencyType === "crewmate" ? "active" : ""}`}
                onClick={() => setCurrencyType("crewmate")}
                style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '4px',
                  border: currencyType === "crewmate" ? '2px solid #4A90E2' : '1px solid var(--border-color)',
                  background: currencyType === "crewmate" ? 'rgba(74, 144, 226, 0.2)' : 'var(--bg-card)',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                🔵 Crewmate Tokens
              </button>
              <button
                className={`currency-select-btn ${currencyType === "imposter" ? "active" : ""}`}
                onClick={() => setCurrencyType("imposter")}
                style={{
                  flex: 1,
                  padding: '10px',
                  borderRadius: '4px',
                  border: currencyType === "imposter" ? '2px solid #E74C3C' : '1px solid var(--border-color)',
                  background: currencyType === "imposter" ? 'rgba(231, 76, 60, 0.2)' : 'var(--bg-card)',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                🔴 Imposter Tokens
              </button>
            </div>
          </div>

          {/* Price Input */}
          <div className="form-group" style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
              {auctionMode ? 'Starting Bid:' : 'Price:'}
            </label>
            <input
              type="number"
              className="price-input"
              placeholder="Enter price in tokens"
              min="0.01"
              step="0.01"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid var(--border-color)',
                background: 'var(--bg-card)',
                color: 'var(--text-primary)',
                fontSize: '16px'
              }}
            />
          </div>

          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: '12px', width: '100%' }}>
            <button
              className="btn-primary"
              onClick={onClose}
              style={{
                flex: 1,
                background: '#666',
                border: '2px solid #555'
              }}
            >
              Cancel
            </button>
            <button
              className="btn-primary"
              onClick={handleList}
              style={{ flex: 1 }}
            >
              List Item for {price || '?'} {currencyType === "crewmate" ? "🔵" : "🔴"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListingModal;
